import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  noPaddingX: {
    padding: '5px 0',
  },
}));

export default useStyles;
